import objectPrefix from '../../lib/objectPrefix';

const prefix = objectPrefix();

module.exports = {

    pumperBaldGuy1: {
        type: 'movieclip',
        scale: {
            x: '100%',
        },
        position: {
            x: '8%',
            y: '4%',
        },
        texture: `sprite:/img/partials/pumpers/bald-guy/bald-guy-${prefix}.json,1/bald-guy`,
        particles: [
            {
                x: '67.6%',
                y: '17.9%',
                angle: 310,
                emit: false,
            },
            {
                x: '65.7%',
                y: '17.3%',
                angle: 310,
                emit: false,
            },
            {
                x: '64.5%',
                y: '17.5%',
                angle: 310,
                emit: false,
            },
            {
                x: '61.3%',
                y: '16.7%',
                angle: 310,
                emit: true,
            },
            {
                x: '61.4%',
                y: '16.5%',
                angle: 305,
                emit: true,
            },
            {
                x: '68.2%',
                y: '17.7%',
                angle: 310,
                emit: false,
            },
            {
                x: '65.8%',
                y: '17.5%',
                angle: 310,
                emit: false,
            },
            {
                x: '65.9%',
                y: '17.4%',
                angle: 310,
                emit: false,
            },
            {
                x: '70.5%',
                y: '18.8%',
                angle: 315,
                emit: true,
            },
        ],
    },

    pumperBaldGuy2: {
        type: 'movieclip',
        scale: {
            x: '100%',
        },
        position: {
            x: '8%',
            y: '4%',
        },
        // texture: `sprite:/img/partials/pumpers/bald-guy/bald-guy-${prefix}.json,2/bald-guy`,
        texture: `sprite:/img/partials/pumpers/bald-guy/bald-guy-${prefix}.json,1/bald-guy`,
        // particles: [
        //     {
        //         x: '83%',
        //         y: '22.2%',
        //         angle: 330,
        //         emit: true,
        //     },
        //     {
        //         x: '82.5%',
        //         y: '21.5%',
        //         angle: 330,
        //         emit: false,
        //     },
        //     {
        //         x: '82.6%',
        //         y: '22.1%',
        //         angle: 330,
        //         emit: false,
        //     },
        //     {
        //         x: '79.7%',
        //         y: '21.6%',
        //         angle: 330,
        //         emit: false,
        //     },
        //     {
        //         x: '77.7%',
        //         y: '21.9%',
        //         angle: 330,
        //         emit: true,
        //     },
        //     {
        //         x: '73.5%',
        //         y: '20.4%',
        //         angle: 330,
        //         emit: true,
        //     },
        //     {
        //         x: '75.2%',
        //         y: '22.6%',
        //         angle: 330,
        //         emit: true,
        //     },
        //     {
        //         x: '78.6%',
        //         y: '23.7%',
        //         angle: 330,
        //         emit: false,
        //     },
        //     {
        //         x: '78.7%',
        //         y: '22.4%',
        //         angle: 330,
        //         emit: false,
        //     },
        //     {
        //         x: '75.7%',
        //         y: '21.3%',
        //         angle: 330,
        //         emit: false,
        //     },
        //     {
        //         x: '74.3%',
        //         y: '21.4%',
        //         angle: 330,
        //         emit: true,
        //     },
        //     {
        //         x: '71.3%',
        //         y: '21.1%',
        //         angle: 330,
        //         emit: true,
        //     },
        // ],
        particles: [
            {
                x: '67.6%',
                y: '17.9%',
                angle: 310,
                emit: false,
            },
            {
                x: '65.7%',
                y: '17.3%',
                angle: 310,
                emit: false,
            },
            {
                x: '64.5%',
                y: '17.5%',
                angle: 310,
                emit: false,
            },
            {
                x: '61.3%',
                y: '16.7%',
                angle: 310,
                emit: true,
            },
            {
                x: '61.4%',
                y: '16.5%',
                angle: 305,
                emit: true,
            },
            {
                x: '68.2%',
                y: '17.7%',
                angle: 310,
                emit: false,
            },
            {
                x: '65.8%',
                y: '17.5%',
                angle: 310,
                emit: false,
            },
            {
                x: '65.9%',
                y: '17.4%',
                angle: 310,
                emit: false,
            },
            {
                x: '70.5%',
                y: '18.8%',
                angle: 315,
                emit: true,
            },
        ],
    },

    pumperBaldGuy3: {
        type: 'movieclip',
        scale: {
            x: '100%',
        },
        position: {
            x: '8%',
            y: '4%',
        },
        // texture: `sprite:/img/partials/pumpers/bald-guy/bald-guy-${prefix}.json,3/bald-guy`,
        texture: `sprite:/img/partials/pumpers/bald-guy/bald-guy-${prefix}.json,1/bald-guy`,
        // particles: [
        //     {
        //         x: '71.2%',
        //         y: '21.7%',
        //         angle: 320,
        //         emit: false,
        //     },
        //     {
        //         x: '74.5%',
        //         y: '20.7%',
        //         angle: 320,
        //         emit: false,
        //     },
        //     {
        //         x: '71.1%',
        //         y: '23.4%',
        //         angle: 320,
        //         emit: true,
        //     },
        //     {
        //         x: '74.6%',
        //         y: '22.3%',
        //         angle: 320,
        //         emit: false,
        //     },
        //     {
        //         x: '72.6%',
        //         y: '24.2%',
        //         angle: 320,
        //         emit: true,
        //     },
        //     {
        //         x: '73.8%',
        //         y: '24.4%',
        //         angle: 320,
        //         emit: false,
        //     },
        //     {
        //         x: '71.5%',
        //         y: '23.6%',
        //         angle: 320,
        //         emit: true,
        //     },
        //     {
        //         x: '70.4%',
        //         y: '22.3%',
        //         angle: 320,
        //         emit: false,
        //     },
        //     {
        //         x: '74.8%',
        //         y: '25%',
        //         angle: 320,
        //         emit: true,
        //     },
        //     {
        //         x: '77.5%',
        //         y: '24%',
        //         angle: 320,
        //         emit: false,
        //     },
        //     {
        //         x: '71%',
        //         y: '22%',
        //         angle: 320,
        //         emit: true,
        //     },
        // ],
        particles: [
            {
                x: '67.6%',
                y: '17.9%',
                angle: 310,
                emit: false,
            },
            {
                x: '65.7%',
                y: '17.3%',
                angle: 310,
                emit: false,
            },
            {
                x: '64.5%',
                y: '17.5%',
                angle: 310,
                emit: false,
            },
            {
                x: '61.3%',
                y: '16.7%',
                angle: 310,
                emit: true,
            },
            {
                x: '61.4%',
                y: '16.5%',
                angle: 305,
                emit: true,
            },
            {
                x: '68.2%',
                y: '17.7%',
                angle: 310,
                emit: false,
            },
            {
                x: '65.8%',
                y: '17.5%',
                angle: 310,
                emit: false,
            },
            {
                x: '65.9%',
                y: '17.4%',
                angle: 310,
                emit: false,
            },
            {
                x: '70.5%',
                y: '18.8%',
                angle: 315,
                emit: true,
            },
        ],
    },

    baldGuyPump: {
        scale: {
            x: '100%',
        },
        position: {
            x: '8%',
            y: '4%',
        },
        texture: '/img/partials/pumpers/bald-guy/pump.png',
    },

    baldGuyPumpBackground: {
        scale: {
            x: '100%',
        },
        texture: '/img/partials/pumpers/bald-guy/bg.jpg',
    },

    diplomeBaldGuy: {
        texture: '/img/partials/pumpers/bald-guy/diplome.png',
        scale: {
            x: '34%',
        },
        position: {
            x: '8%',
            y: '20%',
        },
    },

};



// WEBPACK FOOTER //
// ./js/objects/partials/baldGuyPump.js